import React from 'react';
import Header from '../components/Header';
import './About.css';

const About = () => {
  return (
    <div className="about-page">
      <div className="about-content">
        <div className="about-container">
          <div className="message-box">
            <h1>關於我們</h1>
            <p>
              ErnieToTech 是專注於服務零股玩家的軟體供應商，致力於提供高效率的投票解決方案。我們開發的電腦投票軟體結合網站自動化服務，協助客戶快速處理繁瑣的股東會投票流程，特別適合持有大量零股的投資人或代操帳戶管理者使用。
            </p>
          </div>
          
          <div className="contact-section">
            <h1>聯絡我們</h1>
            <div className="line-contact">
              <div className="qr-code">
                <img src="/line-qr.jpg" alt="LINE QR Code" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About; 